import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/adjustment/";

export default class AdjustmentApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getAdjustments(params) {
    return await request.post(`${rootRoute}getAdjustments`, {
      filter: params,
      parameters: {},
    });
  }
  async getAdjustment(data) {
    return await request.post(`${rootRoute}getAdjustments`, {
      filter: `$filter=Id eq ${data.id} and MarsPeriodId eq ${data.periodId}`,
      parameters: {},
    });
  }
  async getAddressProgramsByAdjustmentId(filter) {
    return await request.post(`${rootRoute}getAddressProgramsByAdjustmentId`, {
      filter: filter,
      parameters: {},
    });
  }
  async approveAdjustment(model) {
    return await request.post(`${rootRoute}approveadjustment`, {data: model});
  }
  async acceptAdjustment(model) {
    return await request.post(`${rootRoute}acceptadjustment`, {data: model});
  }

  async acceptAdjustments(params) {
    return await request.post(`${rootRoute}acceptadjustments`, params);
  }

  async approveAdjustments(params) {
    return await request.post(`${rootRoute}approveadjustments`, params);
  }

  async createAdjustment(model) {
    const data = _.merge(_.cloneDeep(this.defaultModel), model);
    return await request.post(`${rootRoute}createAdjustment`, { data });
  }
  async deleteAdjustments(models) {
    const data = models;
    return await request.post(`${rootRoute}deleteAdjustment`, data);
  }
  async editAdjustment(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateAdjustment`, { data });
  }
  async editAdjustments(models) {
    const data = models;
    return await request.post(`${rootRoute}updateAdjustment`, { data });
  }
  async getAdjustmentStatusCount(params) {
    return await request.post(`${rootRoute}getAdjustmentStatusCount`, {
      filter: params,
      parameters: {},
    });
  }
  async export(marsPeriod, filter, format) {
    return await request.post(`${rootRoute}exportAdjustment`, {
      marsPeriod: marsPeriod,
      filter: filter,
      format: format
    });
  }
}
